import { useTranslation } from 'react-i18next';
import TypeCheckbox from '../../../form/form-fields/TypeCheckbox';

export const MatchingPropLeadFieldCheckbox = ({ property, onChange }) => {
  const { t } = useTranslation();

  const valueField = {
    label: property.label,
    key: 'minValue',
    unit: property.unit,
  };

  function handleUpdate(key, value) {
    const newProp = { ...property, [key]: value };
    onChange(newProp);
  }

  return (
    <TypeCheckbox
      size="small"
      field={valueField}
      dataCollection={property}
      updateValidationOnChange={handleUpdate}
    />
  );
};
